/**
 * Route for `campaign-device-targeting`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { CampaignDeviceTargetingPage } from "../features/campaign-device-targeting/CampaignDeviceTargetingPage";

export const campaignDeviceTargetingRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/campaign-device-targeting",
	component: CampaignDeviceTargetingPage,
});

export default campaignDeviceTargetingRoute;
